export default {
    activeTeamMembers: 'Active Team Members',
    admin: 'Admin',
    apiApplication: 'API Application',
    apiApplications: 'API Applications',
    clearSearch: 'Clear search',
    distributeLicenses: 'Distribute Licenses',
    emailVerificationBanner:
        'For better security and service, MakeLeaps requires you to complete Primary Email verification before inviting team members.',
    emailVerificationBannerButton: 'To Email Settings',
    invite: {
        bulkInvite: 'Bulk invite (data import)',
        inviteOneMember: 'Invite one Member',
        inviteTeamMembers: 'Invite Team Members',
    },
    invited: 'Invited',
    licensed: 'Licensed',
    name: 'Name',
    noResults: 'No results matched',
    ownerAdmin: 'Owner/Admin',
    rightsForMakeLeapsApi:
        'Rights for <0>MakeLeaps API keys</0> can be managed like a Team Member.',
    transferOwnership: 'Transfer Ownership',
    usageLimitMessage:
        'You may have unlimited team members, but you have reached your limit of {{activeUserLimit}} full access team members. <0>Upgrade your plan</0> to add additional full-access team members.',
    usageLimitUnlimited:
        'You may have unlimited team members in the {{planName}}s plan.',
    viewRights: 'View Rights',
    you: 'You',
};
